/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

function useWindowSize(triggerSize, setValue) {
  const isClient = typeof window === 'object';

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);

    if (windowSize.width <= triggerSize) {
      setValue(false);
    } else setValue(true);

    return () => window.removeEventListener('resize', handleResize);
  }, [getSize, isClient, setValue, triggerSize, windowSize.width]);
}

export default useWindowSize;
